module.exports = __webpack_public_path__ + "static/media/bd.d08a5ccc.svg";